import React from "react";
import vendedorService from "../../_services/cart/vendedor.service";
import { connect } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { userActions } from "../../_actions";
import { history } from "../../_helpers";
import authService from "../../_services/cart/authService";
import { FormDatosUsuario } from "../perfil/FormDatosUsuario";
import { PanelSeguridad } from "../perfil/PanelSeguridad";
import { FormContactosVendedor } from "./FormContactosVendedor";
import { NavBarLateral } from "./NavBarLateral";

class MiPerfil extends React.Component {
  state = {
    showContactos: false,
  };

  handleClose = () => {
    this.setState({ showContactos: false });
  };

  /** Mercado Pago activo o no: es la misma tarjeta con distinto tono. */
  renderMercadoPago() {
    const habilitado = authService.isMercadoPagoHabilitado();

    return (
      <div className="dashboard__profile">
        <div className="dashboard__profile-icon">
          <div className="dashboard__profile-icon--mp">
            <FontAwesomeIcon
              icon={
                habilitado
                  ? "fa-regular fa-circle-check"
                  : "fa-solid fa-circle-exclamation"
              }
            />{" "}
            <img
              src={process.env.PUBLIC_URL + "/images/mp-logo.png"}
              width="130"
              height="auto"
              className="d-inline-block align-top mp-logo"
              alt="Mercado Pago"
            />
          </div>
          <span>
            {habilitado ? " Mercado Pago activo" : " Mercado Pago NO activo"}
          </span>
        </div>

        <button
          className="button"
          data-type={habilitado ? "complementary" : "accent"}
          type="button"
          onClick={() => history.push("/vendedor/miMp")}
        >
          {habilitado ? "Ver detalles" : "¿Cómo activarla?"}
        </button>
      </div>
    );
  }

  render() {
    /* Un empleado de una cuenta tiene el rol de vendedor (lo hereda del dueño)
       pero este perfil es el suyo: el cobro y la tienda son de la cuenta y los
       maneja el dueño. Para el, el perfil es solo de datos personales. */
    const esEmpleado = authService.hasAuthority("VENDEDOR") && !authService.esDuenoCuenta();
    const esVendedor = authService.hasAuthority("VENDEDOR") && !esEmpleado;

    return (
      <>
        <div className="dashboard">
          <NavBarLateral handleClose={this.handleClose} />
          <div className="dashboard__content">
            <div className="dashboard__content-header">
              <div className="dashboard__content-title">
                <h2>Mi perfil</h2>
              </div>
            </div>
            <div className="dashboard__content-subheader">
              <h3 className="small">
                Acá podés cambiar tus datos personales, de ubicación y de cobro.
              </h3>
            </div>

            {/*
              El form envuelve a los <Tabs> y le presta sus secciones a cada una: los
              datos de cobro van con Mercado Pago en "Cobros", y los de ubicación con la
              tienda en "Mi tienda", que es donde la persona los va a buscar. Sigue
              siendo un solo formulario, asi que "Grabar cambios" guarda todo el perfil
              desde cualquier solapa.
            */}
            <FormDatosUsuario
              className="bg-iot"
              accion="actualizar"
              esVendedor={esVendedor}
            >
              {({ secciones, botonGrabar }) => (
                /* mountOnEnter: cada solapa pide lo suyo (provincias, contactos)
                   recién cuando se abre. */
                <Tabs id="perfil-vendedor-tabs" defaultActiveKey="datos" mountOnEnter>
                  <Tab eventKey="datos" title="Mis datos">
                    <div className="perfil__panel">
                      {secciones.datosUsuario}
                      {secciones.perfil}
                      {secciones.redes}
                      {secciones.imagenes}
                      {botonGrabar}
                    </div>
                  </Tab>

                  {!esEmpleado && (
                  <Tab eventKey="cobros" title="Cobros">
                    <div className="perfil__panel">
                      <h4>Medios de pago habilitados</h4>
                      <div className="dashboard__content-prod">
                        {this.renderMercadoPago()}
                      </div>

                      {secciones.pago}
                      {secciones.pago && botonGrabar}
                    </div>
                  </Tab>
                  )}

                  {esVendedor && (
                    <Tab eventKey="tienda" title="Mi tienda">
                      <div className="perfil__panel">
                        <h4>Sitio del vendedor</h4>
                        <div className="dashboard__content-prod">
                          <div className="dashboard__profile">
                            <div className="dashboard__profile-icon">
                              <FontAwesomeIcon icon="fa-regular fa-id-card" size="4x" />
                              <span>Así ven los compradores tu tienda</span>
                            </div>
                            <Link
                              className="button"
                              data-type="primary"
                              target="_blank"
                              to={vendedorService.crearUrlTienda(
                                authService.getLoggedUserDetail()
                              )}
                            >
                              Ver mi tienda
                            </Link>
                          </div>
                        </div>

                        <h4>Contactos de WhatsApp</h4>
                        <div className="dashboard__content-prod">
                          <div className="dashboard__profile">
                            <div className="dashboard__profile-icon">
                              <FontAwesomeIcon
                                icon="fa-brands fa-whatsapp"
                                size="4x"
                              />
                              <span>
                                Sumá a las personas que trabajan con vos: cuando
                                alguien consulte por una publicación tuya va a poder
                                elegir a quién escribirle.
                              </span>
                            </div>
                            <button
                              className="button"
                              data-type="complementary"
                              type="button"
                              onClick={() => this.setState({ showContactos: true })}
                            >
                              Configurar
                            </button>
                          </div>
                        </div>

                        {secciones.ubicacion}
                        {botonGrabar}
                      </div>
                    </Tab>
                  )}

                  <Tab eventKey="seguridad" title="Seguridad">
                    <div className="perfil__panel">
                      <PanelSeguridad />
                    </div>
                  </Tab>
                </Tabs>
              )}
            </FormDatosUsuario>
          </div>
        </div>

        {this.state.showContactos && (
          <FormContactosVendedor
            show={this.state.showContactos}
            handleClose={this.handleClose}
          />
        )}
      </>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {
  traerMiPerfil: userActions.traerMiPerfil,
};

const connectedMiPerfil = connect(mapState, actionCreators)(MiPerfil);
export { connectedMiPerfil as MiPerfil };
